// extracted by mini-css-extract-plugin
export default {"title":"PaneTitle-module__title__P2adb","icon":"PaneTitle-module__icon__5sWVJ"};